var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M151.428,240v-56c0-53.016,42.984-96,96-96l0,0c53.016,0,96,42.984,96,96v56H151.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M247.428,88c-2.704,0-5.352,0.184-8,0.4c49.264,4.08,88,45.28,88,95.6v56h16v-56 C343.428,130.984,300.444,88,247.428,88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1360ef"
    },
    d: "M215.428,424h176l-15.016-45.04c-5.544-16.624-19.704-28.912-36.952-32.048L279.428,336h-64 l-60.04,10.912c-17.24,3.136-31.408,15.416-36.952,32.048l-7.008,31.848V424H215.428z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9E0A6"
    },
    points: "215.428,312 215.428,336 247.428,368 279.428,336 279.428,312  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E0A6"
    },
    d: "M311.428,216h8c13.256,0,24,10.744,24,24l0,0c0,13.256-10.744,24-24,24h-8V216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E0A6"
    },
    d: "M183.428,216h-8c-13.256,0-24,10.744-24,24l0,0c0,13.256,10.744,24,24,24h8V216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E0A6"
    },
    d: "M175.428,208v48c0,39.768,32.232,72,72,72l0,0c39.768,0,72-32.232,72-72v-48l0,0 c-25.608,0-50.176-10.176-68.288-28.288L247.428,176l-3.712,3.712C225.604,197.824,201.036,208,175.428,208L175.428,208z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1360ef"
    },
    d: "M303.428,256c0,37.056-28.008,67.544-64,71.528c2.632,0.296,5.296,0.472,8,0.472 c39.768,0,72-32.232,72-72v-48c-5.4,0-10.744-0.552-16-1.432V256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f94f15"
    },
    d: "M359.428,8h112c8.84,0,16,7.16,16,16v64c0,8.84-7.16,16-16,16h-24l-64,40l6.856-40h-30.856 c-8.84,0-16-7.16-16-16V24C343.428,15.16,350.588,8,359.428,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1360ef"
    },
    d: "M356.764,424h34.664l-15.016-45.04c-5.544-16.624-19.704-28.912-36.952-32.048L279.428,336 l57.56,31.976c9.056,5.032,15.12,14.136,16.264,24.44L356.764,424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB5968"
    },
    d: "M183.428,395.88l-28.688,25.944c-6.248,6.248-16.376,6.248-22.624,0L74.74,364.448 c-6.248-6.248-6.248-16.376,0-22.624l25.944-25.944l-48-48l-30.056,30.056c-18.744,18.744-18.744,49.136,0,67.88l108.12,108.12 c18.744,18.744,49.136,18.744,67.88,0l32.8-30.056L183.428,395.88z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.004,376.432c-6.472-19.4-22.984-33.72-43.112-37.384l-53.464-9.728v-4.144c9.304-5.4,17.4-12.624,23.848-21.176h16.152 c13.232,0,24-10.768,24-24v-96c0-57.344-46.656-104-104-104s-104,46.656-104,104v56c0,15.424,10.968,28.328,25.512,31.336 c4.488,22.992,18.856,42.448,38.488,53.84v4.144l-53.472,9.728c-20.12,3.664-36.64,17.984-43.104,37.384l-3.2,9.608l-27.248-27.248 c-3.12-3.12-3.12-8.2,0-11.32l31.6-31.592l-59.312-59.312L16.98,292.28c-10.576,10.576-16.4,24.64-16.4,39.6 s5.824,29.016,16.4,39.592l108.12,108.12C135.676,490.168,149.74,496,164.7,496s29.016-5.832,39.344-16.168l38.968-35.704 L230.86,432h171.664L384.004,376.432z M247.428,356.688l-24-24v-0.376c7.584,2.384,15.64,3.688,24,3.688 c8.36,0,16.416-1.304,24-3.688v0.376L247.428,356.688z M327.428,288H320.7c2.32-5.288,4.08-10.864,5.216-16.664 c3.424-0.712,6.576-2.072,9.512-3.784V280C335.428,284.416,331.836,288,327.428,288z M327.428,226.224c4.76,2.776,8,7.88,8,13.776 s-3.24,11-8,13.776V226.224z M159.428,240c0-5.896,3.24-11,8-13.776v27.552C162.668,251,159.428,245.896,159.428,240z M167.428,200 v9.136c-2.848,0.744-5.52,1.864-8,3.312V184c0-48.52,39.48-88,88-88s88,39.48,88,88v28.448c-2.48-1.448-5.152-2.576-8-3.312V200h-8 c-23.656,0-45.896-9.216-62.632-25.944l-9.368-9.368l-9.368,9.368C221.324,190.784,199.084,200,175.428,200H167.428z M183.428,256 v-40.304c24.024-1.808,46.424-11.72,64-28.432c17.576,16.712,39.976,26.632,64,28.432V256c0,11.664-3.184,22.576-8.656,32h-55.344 v16h42.192c-11.28,9.928-26.024,16-42.192,16C212.14,320,183.428,291.288,183.428,256z M89.372,315.88l-8.688,8.688L43.996,287.88 l8.688-8.688L89.372,315.88z M164.684,480c-10.68,0-20.728-4.168-28.288-11.72L28.276,360.168 c-7.552-7.552-11.712-17.6-11.712-28.28c0-10.688,4.16-20.736,11.712-28.288l4.4-4.4l36.688,36.688l-0.288,0.288 c-9.352,9.36-9.352,24.584,0,33.944l57.368,57.368c4.536,4.528,10.56,7.032,16.976,7.032s12.44-2.496,16.68-6.752l0.6-0.536 l36.856,36.856l-4.592,4.208C185.412,475.832,175.364,480,164.684,480z M209.364,453.256l-36.776-36.776l10.568-9.552l36.712,36.712 L209.364,453.256z M214.86,416l-31.16-31.16l-34.624,31.32c-3.016,3.032-8.288,3.032-11.312,0l-17.472-17.472l5.728-17.2 c4.616-13.856,16.416-24.088,30.792-26.712l55.92-10.16l34.696,34.696l34.688-34.688l55.912,10.16 c14.376,2.624,26.176,12.848,30.792,26.712L380.332,416H214.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471.428,0h-112c-13.232,0-24,10.768-24,24v64c0,13.232,10.768,24,24,24h21.368l-8.272,48.248l77.2-48.248h21.704 c13.232,0,24-10.768,24-24V24C495.428,10.768,484.66,0,471.428,0z M479.428,88c0,4.408-3.592,8-8,8h-26.296l-50.808,31.752 L399.772,96h-40.344c-4.408,0-8-3.592-8-8V24c0-4.408,3.592-8,8-8h112c4.408,0,8,3.592,8,8V88z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 367.428,
    y: 32,
    width: 96,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 367.428,
    y: 64,
    width: 64,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 447.428,
    y: 64,
    width: 16,
    height: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.548,198.856l-8.232-13.72l-21.68,13.008C68.308,105.88,151.276,40,247.428,40c21.016,0,41.752,3.12,61.632,9.28 L313.796,34c-21.416-6.64-43.744-10-66.368-10C142.9,24,52.86,96.304,29.452,197.16l-15.16-25.272l-13.72,8.232l28.12,46.856 L75.548,198.856z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M416.572,195.88l13.72,8.232l14-23.336c7.368,21.56,11.136,44.112,11.136,67.224c0,47.576-16.48,94.088-46.392,130.96 l12.424,10.08c32.224-39.712,49.968-89.808,49.968-141.04c0-24.472-3.944-48.368-11.632-71.248l23.512,14.104l8.232-13.72 l-46.856-28.12L416.572,195.88z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.240288491d6d980829dd6c7d3e115137.svg";
export { ForwardRef as ReactComponent };